import { classnames } from '@aibees/shared/utils';
import { Paper, Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import { Icon } from '../icon';
import * as Styled from './styles';
import * as SX from './sx';
import type { DataNotFoundProps as Props } from './types';

export const DataNotFound = memo(
  ({ className, icon, title, titleSx, sx, titleWrapperSx }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('DataNotFound', className)}
        sx={mergeSx(SX.root, sx)}
      >
        <Paper variant="outlined" sx={SX.emptyIconWrapper}>
          <Icon name={icon} sxx={SX.emptyIcon} size={36} />
        </Paper>

        <Paper
          variant="outlined"
          sx={mergeSx(SX.notFoundTitleWrapper, titleWrapperSx)}
        >
          <Typography sx={mergeSx(SX.notFoundTitle, titleSx)}>
            {title}
          </Typography>
        </Paper>
      </Styled.Wrapper>
    );
  }
);

DataNotFound.displayName = 'DataNotFound';
